import axios from "axios";

import config from "@app/config";
import { NormalisedVariant } from "../types";
import _ from "lodash";

export const decodeShopifyId = (id: string | number, type: string) => {
  return id?.split?.(`${type}/`)?.[1] || id;
};

export const addToCart = async ({
  id,
  qty,
  properties = null,
}: {
  id: number | string;
  qty: string | number;
  properties: { [key: string]: string } | null;
}) => {
  const data = {
    id: decodeShopifyId(id, "Variant"),
    quantity: qty,
  };
  if (properties) data.properties = properties;

  const res = await axios({
    method: "POST",
    url: "/cart/add.js",
    data: JSON.stringify(data),
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "xmlhttprequest",
    },
  })
    .then((result) => {
      if (result.status === 200) {
        // Always increment a successful cart purchase
        document.querySelectorAll("[data-cart-count]")?.forEach((x) => (x.innerText = parseInt(x.innerText) + 1));
        const event = new CustomEvent("cartAdd");

        if (window.location.pathname !== "/cart") {
          window.dispatchEvent(event);
        } else {
          location.reload();
        }
      }
      return result;
    })
    .catch((error) => error.response.data);

  return res;
};

export const updateLineProperties = async ({
  lineIndex,
  properties,
}: {
  lineIndex: number;
  properties: { [key: string]: string };
}) => {
  const res = await axios({
    method: "POST",
    url: "/cart/change.js",
    data: JSON.stringify({
      line: lineIndex,
      properties,
    }),
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "xmlhttprequest",
    },
  })
    .then((result) => result)
    .catch((error) => error.response.data);

  return res;
};

export const updateCart = async ({ id, qty }: { id: number | string; qty: number }) => {
  const res = await axios({
    method: "POST",
    url: "/cart/update.js",
    data: JSON.stringify({
      updates: {
        [id]: qty,
      },
    }),
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "xmlhttprequest",
    },
  })
    .then((result) => {
      if (result.status === 200) {
        // Always update a successful cart purchase
        if (!isNaN(result?.data?.item_count))
          document.querySelectorAll("[data-cart-count]")?.forEach((x) => (x.innerText = result.data.item_count));
      }
      return result;
    })
    .catch((error) => error.response.data);

  return res;
};

export const addToBackInStock = async ({
  email,
  variantId,
  productId,
  store,
  addMe,
}: {
  email: string;
  variantId: number;
  productId: number;
  store: string;
  addMe: boolean;
}) => {
  const res = await axios
    .post(
      "https://a.klaviyo.com/onsite/components/back-in-stock/subscribe",
      {
        a: config.stores[`${store}`].klaviyoId,
        g: addMe && config.stores[`${store}`].klaviyoList,
        product: `${productId}`,
        variant: `${variantId}`,
        email: email,
        platform: "shopify",
      },
      {
        headers: {
          "content-type": "application/x-www-form-urlencoded",
        },
      }
    )
    .then((result) => result)
    .catch((error) => error?.response?.data);
  return res;
};

export const formatPrice = (price: number, currencyCode = "AUD") => {
  const f = new Intl.NumberFormat("en-" + currencyCode.slice(0, 2), {
    style: "currency",
    currency: currencyCode,
  });

  return f.format(price);
};

export const isUS = Shopify?.shop.includes(config.stores["industrie-australia"].shopify_domain);

export const extractIdFromGid = (gid: string) => gid.match(/[^/]+$/i)?.[0]

export const sortVariants = (variants?: NormalisedVariant[]) => variants && variants.length > 1
  ? _.sortBy(variants, (obj) => {
    const title = obj.title;
    if (title === "000" || title === "OOO") return 0;
    if (title === "00" || title === "OO") return 1;
    if (title === "0" || title === "O") return 2;
    return parseInt(title) + 3;
  })
  : undefined;

